// What the editor shows, as a PURE reducer (spec §5: "the previous valid document stays on screen").
//   doc    — what the user asked for: the controls always show this, and every change builds on it
//   shown  — the last layout the worker accepted: { doc, view, backView, issues } — the canvas draws
//            `view` (front) or `backView` (as seen from the back), whichever face is being edited
//   error  — why `doc` is not what is shown (null when it is)
// Downloads are allowed only when the canvas shows exactly what was asked for, with no issues.
import { S } from '../strings.js';
export const createSession = (doc) => ({ doc, shown: null, error: null });

export const propose = (session, doc) => ({ ...session, doc });

// reply: the worker's answer to a `layout` request for `requestedDoc`.
// A reply for a document that is no longer the current one is stale and ignored.
export function settle(session, requestedDoc, reply) {
  if (requestedDoc !== session.doc) return session;
  if (!reply.ok) return { ...session, error: reply.error };
  // the template filled in placements: adopt them, so the next change builds on the placed document
  return { doc: reply.doc, shown: { doc: reply.doc, view: reply.view, backView: reply.backView, issues: reply.issues }, error: null };
}

export function downloadState(session) {
  if (session.error) return { ok: false, note: session.error.message };
  if (!session.shown) return { ok: false, note: S.loading };
  if (session.shown.issues.length > 0) return { ok: false, note: session.shown.issues[0].message };
  return { ok: true, note: '' };
}
